import '../styles/paginatedView.css';
import React from "react";
import PropTypes from 'prop-types';

class Pagination extends React.Component {
    constructor(props, context) {
        super(props, context);
        const startingPage = props.startingPage ? props.startingPage : 1;
        const data = props.data;
        const pageSize = props.pageSize;
        let pageCount = parseInt(data.length / pageSize);
        if (data.length % pageSize > 0) {
            pageCount++;
        }
        this.state = {
            currentPage: startingPage,
            pageCount: pageCount
        };
    }

    // FIX #1: Reset currentPage to 1 when data length changes (e.g. after filtering)
    componentDidUpdate(prevProps) {
        if (prevProps.data.length !== this.props.data.length) {
            this.setState({ currentPage: 1 });
        }
    }

    setCurrentPage(num) {
        this.setState({currentPage: num});
    }

    // FIX #2: Sliding-window pagination with max 5 numbered buttons + Prev/Next arrows
    createControls() {
        const data = this.props.data;
        const pageSize = this.props.pageSize;
        let pageCount = parseInt(data.length / pageSize);
        if (data.length % pageSize > 0) {
            pageCount++;
        }
        if (pageCount <= 1) return null;

        const currentPage = this.state.currentPage;
        const baseClassName = 'pagination-controls__button';

        let controls = [];

        // Prev arrow
        controls.push(
            <div
                key="prev"
                className={`${baseClassName} ${currentPage === 1 ? baseClassName + '--disabled' : ''}`}
                onClick={() => { if (currentPage > 1) this.setCurrentPage(currentPage - 1); }}
            >
                &#8249;
            </div>
        );

        // Determine visible page window (max 5 buttons)
        const MAX_VISIBLE = 5;
        let startPage, endPage;
        if (pageCount <= MAX_VISIBLE) {
            startPage = 1;
            endPage = pageCount;
        } else {
            const half = Math.floor(MAX_VISIBLE / 2);
            startPage = Math.max(1, currentPage - half);
            endPage = startPage + MAX_VISIBLE - 1;
            if (endPage > pageCount) {
                endPage = pageCount;
                startPage = endPage - MAX_VISIBLE + 1;
            }
        }

        // First page + leading ellipsis
        if (startPage > 1) {
            controls.push(
                <div key={1} className={baseClassName} onClick={() => this.setCurrentPage(1)}>1</div>
            );
            if (startPage > 2) {
                controls.push(<div key="ellipsis-start" className={`${baseClassName} ${baseClassName}--ellipsis`}>&hellip;</div>);
            }
        }

        // Numbered page buttons
        for (let i = startPage; i <= endPage; i++) {
            const activeClassName = i === currentPage ? `${baseClassName}--active` : '';
            controls.push(
                <div
                    key={i}
                    className={`${baseClassName} ${activeClassName}`}
                    onClick={() => this.setCurrentPage(i)}
                >
                    {i}
                </div>
            );
        }

        // Trailing ellipsis + last page
        if (endPage < pageCount) {
            if (endPage < pageCount - 1) {
                controls.push(<div key="ellipsis-end" className={`${baseClassName} ${baseClassName}--ellipsis`}>&hellip;</div>);
            }
            controls.push(
                <div key={pageCount} className={baseClassName} onClick={() => this.setCurrentPage(pageCount)}>{pageCount}</div>
            );
        }

        // Next arrow
        controls.push(
            <div
                key="next"
                className={`${baseClassName} ${currentPage === pageCount ? baseClassName + '--disabled' : ''}`}
                onClick={() => { if (currentPage < pageCount) this.setCurrentPage(currentPage + 1); }}
            >
                &#8250;
            </div>
        );

        return controls;
    }

    createPaginatedData() {
        const data = this.props.data;
        const pageSize = this.props.pageSize;
        const currentPage = this.state.currentPage;
        const upperLimit = currentPage * pageSize;
        const dataSlice = data.slice((upperLimit - pageSize), upperLimit);
        return dataSlice;
    }

    render() {
        const data = this.props.data;
        const pageSize = this.props.pageSize;
        let pageCount = parseInt(data.length / pageSize);
        if (data.length % pageSize > 0) pageCount++;

        return (
            <div className='pagination'>
                <div className='pagination-results'>
                    {React.cloneElement(this.props.children, {data: this.createPaginatedData()})}
                </div>
                <div className='pagination-controls'>
                    {this.createControls()}
                </div>
                {pageCount > 1 && (
                    <div className='pagination-info'>
                        Page {this.state.currentPage} of {pageCount}
                    </div>
                )}
            </div>
        );
    }
}

Pagination.propTypes = {
    data: PropTypes.array.isRequired,
    pageSize: PropTypes.number.isRequired,
    startingPage: PropTypes.number.isRequired
};

Pagination.defaultProps = {
    pageSize: 5,
    startingPage: 1
};

class PaginatedView extends React.Component {
    render() {
        return (
            <Pagination
                data={this.props.userData}
                pageSize={this.props.pageSize}
            >
                {this.props.children}
            </Pagination>
        );
    }
}

export default PaginatedView;
